import script from "./AbstractWizardPage.vue?vue&type=script&lang=js"
export * from "./AbstractWizardPage.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__